import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
//import { FinancialSectionsSetFilterService } from './../services/financial-sections-set-filter.service';
import { Subscription } from 'rxjs';
import { ThemeService } from '../theme/theme-service.service';
import { FinancialSummaryCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { FinancialSummaryModeService } from './../services/financial-summary-mode.service';

@Component({
  selector: 'app-financial-summaries-net-income',
  templateUrl: './financial-summaries-net-income.component.html',
  styleUrls: ['./financial-summaries-net-income.component.scss']
})

export class FinancialSummariesNetIncomeComponent implements OnInit {
  public chosentab: string;
  public subscription: Subscription;
  public subscription2: Subscription;
  @Input() public income: number;
  @Input() public expense: number;

  constructor(private router: Router,
    private financialSummaryCategoriesSetFilterService: FinancialSummaryCategoriesSetFilterService,
    private financialSummaryModeService: FinancialSummaryModeService, public themeService: ThemeService) {
  }

  ngOnInit() {
    this.subscription = this.financialSummaryCategoriesSetFilterService.getMessage().subscribe(async filter => {
      this.chosentab = filter;
    });
    this.financialSummaryModeService.changeMessage("true");
  }

  setFilter(filter) {
    this.chosentab = filter;
    this.financialSummaryCategoriesSetFilterService.changeMessage(filter);
    this.financialSummaryModeService.changeMessage("true");
  }
}
